<ng-container *ngIf="isMobileSize; else desktopSize">
	<div class="m-layout-container">
		<div class="m-header">
			<app-mobile-header-customer></app-mobile-header-customer>
		</div>
		<div class="m-content">
			<router-outlet></router-outlet>
		</div>
	</div>
</ng-container>

<ng-template #desktopSize>
	<div class="layout-container">
		<app-sidebar-customer></app-sidebar-customer>

		<div class="content-container">
			<div class="border-container">
				<div class="page-container">
					<router-outlet></router-outlet>
				</div>
			</div>
		</div>
	</div>
</ng-template>
